module.exports = __webpack_public_path__ + "static/img/wang.373f82c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sem/wang.png
// module id = +SfC
// module chunks = 0